// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36WOq","colMin":"styles_colMin__KRbLz"};